import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LocalDevGuard } from '../shared/guards/local-dev.guard';
import { AuthForwardGuard } from './auth-forward.guard';
import { LoginComponent } from './components/login/login.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [AuthForwardGuard, LocalDevGuard],
  },
];

export const AuthRoutes: ModuleWithProviders<RouterModule> = RouterModule.forChild(
  routes
);
